import { AddToBasket } from "components/buttons/add-to-basket";
import Link from "next/link";
import { TicketContainer } from "./ticket-container";
import currency from "currency.js";
import { GetEventQueryResult } from "lib/graphql-generated";
import { useUser } from "lib/hooks/use-user";

interface Props {
  event: GetEventQueryResult["data"]["events"][0];
}

export const OnlineEventTickets = ({ event }: Props) => {
  const { userData } = useUser();

  return (
    <>
      <h3 className='pb-2 pt-4 px-3 text-lg header text-center col-span-full'>
        Online Tickets{" "}
        <Link href='/contact-faq#4'>
          <a className='underline hover:text-gray-600'>(How to watch online)</a>
        </Link>
      </h3>

      {!!userData?.accountId ? (
        <>
          <TicketContainer
            header='Buy ONLINE Event Voucher'
            text={`Includes${" "}
                        ${currency(event.price, {
                          fromCents: true,
                          symbol: "£",
                        }).format()}${" "}
                        voucher redeemable against the book & live viewing/replay of the event online. There are no restrictions to attendance.`}
            button={
              <AddToBasket
                className='whitespace-nowrap my-auto ml-auto mr-auto md:mr-0'
                buttonType='secondary'
                buttonSize='sm'
                payload={{
                  type: "ticket-online-voucher",
                  id: `ticket-online-voucher-${event.id}`,
                  data: {
                    quantity: 1,
                    price: event.price,
                    event: {
                      event_id: event.id,
                      title: event.title,
                      image: event.image,
                    },
                  },
                }}>
                Add to basket{" "}
                {currency(event.price, {
                  fromCents: true,
                  symbol: "£",
                }).format()}
              </AddToBasket>
            }
          />
          {event.event_books.length > 0 && (
            <TicketContainer
              header='Buy Book & Attend ONLINE Event'
              text={`Includes a copy of the book & live viewing/replay of the event online. There are no restrictions to attendance.`}
              button={
                <AddToBasket
                  className='whitespace-nowrap my-auto ml-auto mr-auto md:mr-0'
                  buttonType='secondary'
                  buttonSize='sm'
                  payload={{
                    type: "ticket-online-book",
                    id: `ticket-online-book-${event.id}`,
                    data: {
                      event: {
                        event_id: event.id,
                        title: event.title,
                        image: event.image,
                      },
                      book: {
                        title: event.event_books[0].book.title,
                        isbn: event.event_books[0].book.isbn,
                        image: event.event_books[0].book.image,
                      },
                      price: event.event_books[0].book.price,
                      discount: event.event_books[0].book.is_discounted
                        ? event.event_books[0].book.discount_value
                        : null,
                      quantity: 1,
                    },
                  }}>
                  Add to basket{" "}
                  {currency(event.event_books[0].book.price, {
                    fromCents: true,
                    symbol: "£",
                  }).format()}
                </AddToBasket>
              }
            />
          )}
          <TicketContainer
            header='Reserve Free VIRTUAL Spot'
            text={`If you're broke please do book a free spot to watch live online/replay.`}
            button={
              <AddToBasket
                className='whitespace-nowrap my-auto ml-auto mr-auto md:mr-0'
                buttonType='secondary'
                buttonSize='sm'
                payload={{
                  type: "ticket-online-free",
                  id: `ticket-online-${event.id}`,
                  data: {
                    quantity: 1,
                    event: {
                      event_id: event.id,
                      title: event.title,
                      image: event.image,
                    },
                  },
                }}>
                Add to basket
              </AddToBasket>
            }
          />
        </>
      ) : (
        <p className='col-span-full text-center pb-4 pt-2 font-bold'>
          <Link href='/signin'>
            <a className='text-green-default hover:underline'>Please Sign in</a>
          </Link>
          {` `}Or{` `}
          <Link href='/signup'>
            <a className='text-green-default hover:underline'>Signup</a>
          </Link>
          {` `}
          to Book Online Tickets
        </p>
      )}
    </>
  );
};
